// // components/EducationHero/EducationHero.jsx
// import React from 'react';
// import './HealthHero.css';

// const EducationHero = () => {
//   return (
//     <section className="health-hero">
//       <div className="health-hero-overlay">
//         <div className="health-hero-content">
//           <h1>Our Commitment to Healthcare</h1>
//           <p>Committed to providing quality, affordable, and accessible healthcare across Igboeze North.</p>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default EducationHero;




import React from 'react';
import './HealthHero.css';

const HealthHero = () => {
  return (
    <section className="health-hero">
      <div className="health-hero-overlay">
        <div className="health-hero-content">
          <h1>Our Commitment to Healthcare</h1>
          <p>Committed to providing quality, affordable, and accessible healthcare across Igbo-Eze North.</p>
        </div>
      </div>
    </section>
  );
};

export default HealthHero;